<template>
    <div class="pageBox">
        <div class="pageFrame">
            <el-tabs v-model="activeName" tab-position="left" class="content">
                <el-tab-pane label="中安新闻" name="first">
                    <div class="haveData" v-if="newsList.length>0">
                        <div class="newsList">
                            <router-link :to="{name:'NewsDetail',params:{nId:item.id}}" class="item_news"
                                         v-for="(item,index) in newsList" :key="index">
                                <div class="imgBox">
                                    <img :src="item.newsImg" :alt="item.newsTitle">
                                </div>
                                <div class="newsInfo">
                                    <div class="title">{{ item.newsTitle }}</div>
                                    <div class="info">{{ item.newsInfo }}</div>
                                    <div class="timeRow">
                                        <span class="time">{{ item.baseModifyTime }}</span>
                                        <span class="scan">阅读：{{ item.viewNumber }}</span>
                                    </div>
                                </div>
                            </router-link>
                        </div>
                        <div class="pagination">
                            <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="pageIndex"
                                :page-sizes="[5, 10, 15, 20]"
                                :page-size="pageSize"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="totalCount">
                            </el-pagination>
                        </div>
                    </div>
                    <div class="noData" v-else>暂无数据！</div>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
export default {
    name: "resource",
    data() {
        return {
            activeName: 'first',
            newsList: [],
            totalCount: 15,
            pageSize: 10,
            pageIndex: 1,
            wait: true
        }
    },
    mounted() {
        this.$store.commit('setNav', 4)
        document.title = '中安新闻' + this.$suffix
        this.getNewsList()
    },
    methods: {
        handleSizeChange(val) {
            this.pageSize = val
            this.getNewsList()
        },
        handleCurrentChange(val) {
            this.pageIndex = val
            this.getNewsList()
        },
        /**
         * 获取新闻列表
         */
        getNewsList() {
            this.$post('/V1/News/GetNews',
                {
                    "pageSize": this.pageSize,
                    "pageIndex": this.pageIndex,
                })
                .then((res) => {
                    // console.log('news', res)
                    if (res.success) {
                        this.newsList = res.response.data
                        this.totalCount = res.response.totalCount
                    } else {
                        this.$message.error("网络错误，请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("网络错误，请重试");
                })
        }
    },
}
</script>

<style scoped lang="less">

.pageBox {
    width: 100%;
    background-color: #f9f9f9;

    .pageFrame {
        padding: 20px 0px;
        width: 1210px;
        margin: 0 auto;

        .haveData {

            .newsList {
                display: flex;
                flex-direction: column;
                min-height: 400px;
                width: 860px;
                max-width: 860px;
                padding: 25px 50px;
                overflow: hidden;
                background-color: white;
                box-shadow: 0px 0px 8px 0px #eaeaea;

                .item_news:nth-child(1) {
                    margin-top: 0;
                }

                .item_news {
                    display: flex;
                    flex-direction: row;
                    margin-top: 30px;
                    padding-bottom: 10px;
                    border-bottom: 1px dashed #ccc;

                    .imgBox {
                        width: 200px;
                        min-width: 200px;
                        height: 100px;
                        overflow: hidden;
                        margin-right: 10px;

                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }

                    .newsInfo {
                        display: flex;
                        flex-direction: column;
                        width: 650px;

                        .title {
                            font-size: 18px;
                            color: #333;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            margin-bottom: 3px;
                        }

                        .info {
                            color: #999;
                            font-size: 14px;
                            margin-bottom: 10px;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 2;
                            overflow: hidden;
                        }

                        .timeRow {
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            font-size: 14px;
                            color: #999;

                            .time {
                                margin-right: 50px;
                            }

                            .scan {

                            }
                        }
                    }
                }
            }


            .pagination {
                margin-top: 30px;
            }
        }

        .noData {
            margin: auto auto;
            color: red;
        }

        ::v-deep .el-tabs--left {
            padding: 40px 0px;
        }

        ::v-deep .el-tabs--left .el-tabs__header {
            background-color: white;
            padding: 40px 0px;
            box-shadow: 0px 0px 8px 0px #eaeaea;
            margin-right: 30px;
        }

        ::v-deep .el-tabs--left .el-tabs__content img {
            max-width: 920px;
        }

        ::v-deep .el-tabs--left .el-tabs__content table {
            max-width: 920px;
        }

        ::v-deep .el-tabs--left .el-tabs__item {
            font-size: 18px;
            width: 220px;
            text-align: center;
        }
    }
}
</style>
